function SPRbugfix() {
  /* SPR badges Callback bugfix */
  let batchsize = 7 /* window.SPRSettings.batchSize */;
  let el = $(".shopify-product-reviews-badge[data-id]:not(.SPR-fixed)");
  let test = $.map(el, (
              function(e) {
                  return $(e).attr("data-id")
              }
              ));
              
  while (test.length > 0)
  {
    let batch = test.splice(0, batchsize);
    window['badgesCallback'+batch.join("")] = () => {};
  }

  $(".shopify-product-reviews-badge[data-id]").addClass("SPR-fixed");
}

$(document).ready( () => {
  SPRbugfix();
});
